var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:['status_color_'+_vm.type, 'status_size_'+_vm.size]},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }